import classNames from 'classnames';

import { Text, Picture, Button } from '@farmersdog/corgi-x';

import { useIsMobileViewport } from '../../../hooks/useIsMobileViewport';
import { useVetCustomizedPlan } from '../../../hooks/useVetCustomizedPlan';
import { GetStartedVetCustomizedPlan } from '../GetStartedVetCustomizedPlan';

import { mixedBowl } from './assets/mixedBowl/mixedBowl';
import { Benefits } from './Benefits';
import { Footer } from './Footer';
import styles from './GetStartedInner.module.css';

interface GetStartedInnerProps {
  onComplete: () => void;
}

export function GetStartedInner({ onComplete }: GetStartedInnerProps) {
  const vetCustomizedPlan = useVetCustomizedPlan();

  const isMobile = useIsMobileViewport();

  if (vetCustomizedPlan) {
    return (
      <GetStartedVetCustomizedPlan
        onComplete={onComplete}
        customizedPlan={vetCustomizedPlan}
      />
    );
  }

  return (
    <>
      {!isMobile && (
        <Picture
          sources={mixedBowl}
          alt="Bowl of The Farmer’s Dog Dog Food"
          className={styles.bowl}
        />
      )}

      <div className={styles.textContainer}>
        <Text
          as="h1"
          variant="heading-40"
          color="kale-3"
          bold
          className={classNames(styles.title, styles.withMaxWidth)}
          bottomSpacing={isMobile ? 'md' : 'none'}
          topSpacing={{
            xs: 'sm',
            md: 'xxl',
          }}
        >
          Better food starts here.
        </Text>

        <Text
          as="h2"
          variant={isMobile ? 'article-16' : 'article-20'}
          color="charcoal-3"
          className={classNames(styles.subtitle, {
            [styles.subtitleMobile]: isMobile,
          })}
          topSpacing={{
            xs: isMobile ? 'none' : 'sm',
            md: 'sm',
          }}
          bottomSpacing={{
            xs: 'sm',
            md: 'lg',
          }}
        >
          Let’s determine your meal plan, recommended recipes, and daily price!
        </Text>

        <Text
          variant={isMobile ? 'article-12' : 'article-16'}
          fontStyle="italic"
          color={isMobile ? 'charcoal-2' : 'charcoal-3'}
          as="p"
          topSpacing="none"
          bottomSpacing={{
            xs: 'lg',
            md: '3xl',
          }}
        >
          This will only take ~3 minutes per dog.
        </Text>
      </div>

      {/*
        NOTE: normally we place the submit/continue button on the form component, but because of the unique
        placement on this card and the fact that no data is submitted, we have it here instead.
      */}

      <div className={styles.buttonContainer}>
        <div className={styles.buttonBackground}>
          <Button
            onClick={onComplete}
            aria-label="Continue to signup"
            variant="special"
          >
            Continue
          </Button>
        </div>
      </div>

      <Benefits />

      <Footer />
    </>
  );
}
